function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M15.833 2.5H12.35A2.509 2.509 0 0010 .833c-1.083 0-2 .7-2.35 1.667H4.167C3.25 2.5 2.5 3.25 2.5 4.167v11.666c0 .917.75 1.667 1.667 1.667h11.666c.917 0 1.667-.75 1.667-1.667V4.167c0-.917-.75-1.667-1.667-1.667zM10 2.5c.458 0 .833.375.833.833a.836.836 0 01-.833.834.836.836 0 01-.833-.834c0-.458.375-.833.833-.833zm1.667 11.667H5.833V12.5h5.834v1.667zm2.5-3.334H5.833V9.167h8.334v1.666zm0-3.333H5.833V5.833h8.334V7.5z"
});

function SvgAssignmentIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20
  }, props), _ref);
}

export default SvgAssignmentIcon;